import { resourceable } from '@/store/mixins'

export default {
  namespaced: true,

  mixins: [
    resourceable({
      name: 'techRooms',
      from: ({ api, getters }, { planId, withBoundary } = {}) => 
        api.techRooms.getFloorPlanTechRooms(planId || getters['project/selectedPlan'].id, {
          params: {
            append: [
              withBoundary && 'boundary'
            ].filter(is)
          }
        })      
    })
  ],

  state: {
    roomSellStatuses: null,
    roomTypes: null
  },

  getters: {},

  mutations: {},

  actions: {
    getTechRooms: async function (_, payload = null) {
      let {data} = await this.$api.techRooms.index(payload);
      return data;
    },
    storeTechRoom: async function (_, {payload}) {
      let {data} = await this.$api.techRooms.store(payload);
      return data;
    },
    showTechRoom: async function (_, {
      id,
      payload
    }) {
      let {data} = await this.$api.techRooms.show(id, payload);
      return data;
    },
    updateTechRoom: async function (_, {
      id,
      payload
    }) {
      let {data} = await this.$api.techRooms.update(id, payload);
      return data;
    },
    destroyTechRoom: async function (_, payload) {
      let {data} = await this.$api.techRooms.destroy(payload);
      return data;
    },
    restoreTechRoom: async function (_, id) {
      let {data} = await this.$api.techRooms.restore(id);
      return data;
    }
  }
};

